@if (isMobile()) {
  <div
    data-home-canvas
    class="home-canvas"
    [class.home-canvas-mobile]="isMobile()"
  >
    <app-home-hero
      [content]="homeContent().hero"
      [mobile]="isMobile()"
      (navigate)="scrollToSection($event)"
    ></app-home-hero>
    <div class="home-navigation">
      <h2 class="home-navigation-title">
        {{ homeContent().navigation.heading }}
      </h2>
      <div
        role="tablist"
        aria-label="Trang chủ, ngành hàng và tuyển dụng"
        class="home-tabs"
      >
        @for (tab of tabs(); track tab.id; let index = $index) {
          <button
            type="button"
            role="tab"
            [id]="'home-tab-' + tab.id"
            [attr.aria-selected]="activeTab() === tab.id"
            aria-controls="home-content"
            [attr.tabindex]="activeTab() === tab.id ? 0 : -1"
            class="home-tab"
            [class.home-tab-active]="activeTab() === tab.id"
            (click)="activeTab.set(tab.id)"
            (keydown)="onTabKeydown($event, index)"
          >
            <span class="home-tab-icon"
              ><mat-icon [svgIcon]="'hero:' + tab.icon"></mat-icon
            ></span>
            <span>{{ tab.label }}</span>
          </button>
        }
      </div>
    </div>

    <div
      id="home-content"
      role="tabpanel"
      [attr.aria-labelledby]="'home-tab-' + activeTab()"
      tabindex="0"
      class="home-panel"
      [class.home-panel-contained]="activeTab() !== 'home'"
    >
      @if (activeTab() === "home") {
        <!-- Điện thoại có camera: khối tra cứu / quét QR là lối vào chính, đặt ngay đầu trang chủ. -->

        <app-home-company [content]="homeContent().company"></app-home-company>
        <app-home-solutions
          [content]="homeContent().solutions"
          [mobile]="isMobile()"
          (navigate)="scrollToSection($event)"
        ></app-home-solutions>
        <app-home-commitments
          [content]="homeContent().commitments"
          [mobile]="true"
        ></app-home-commitments>
        <app-home-product-lookup
          [mobile]="true"
          [content]="homeContent().warranty"
        ></app-home-product-lookup>
        <app-home-cta [content]="homeContent().cta"></app-home-cta>
      } @else if (activeTab() === "recruitment") {
        <app-home-recruitment
          [content]="homeContent().recruitment"
        ></app-home-recruitment>
      } @else {
        <app-home-industry
          [content]="activeIndustry()"
          [mobile]="isMobile()"
        ></app-home-industry>
      }
    </div>
  </div>
} @else {
  <div data-home-canvas class="bg-white">
    <app-home-hero
      [content]="homeContent().hero"
      (navigate)="scrollToSection($event)"
    ></app-home-hero>
    <app-home-commitments
      [content]="homeContent().commitments"
    ></app-home-commitments>
    <app-home-industry
      [content]="homeContent().industries[0]"
    ></app-home-industry>
    <app-home-industry
      [content]="homeContent().industries[1]"
    ></app-home-industry>
    <app-home-product-lookup
      [content]="homeContent().warranty"
    ></app-home-product-lookup>
    <app-home-recruitment
      [content]="homeContent().recruitment"
    ></app-home-recruitment>
    <app-home-cta [content]="homeContent().cta"></app-home-cta>
  </div>
}
